export default "__VITE_ASSET__B3tXEIO8__"